import React from "react";
import PropTypes from "prop-types";
import StripeCheckout from "react-stripe-checkout";
import firebase from "firebase";
import "firebase/functions";
import config from "../config";

const updateCard = firebase.functions().httpsCallable("updateCard");
const { stripePublishableKey } = config.stripe;

export default class SubscriptionEdit extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isAwaitingUpdate: false
    };
  }

  componentWillReceiveProps(newProps) {
    if (
      newProps.payment.stripeWebhookProcessedOn !==
      this.props.payment.stripeWebhookProcessedOn
    ) {
      this.setState({ isAwaitingUpdate: false });
    }
  }

  onToken = async token => {
    this.setState({ isAwaitingUpdate: true });
    const result = await updateCard(token);
  };

  onOpen = () => {
    window.analytics.track("Opens Stripe Edit Card Popup");
  };

  render() {
    if (!this.props.user) {
      return null;
    }

    let content;
    if (this.state.isAwaitingUpdate) {
      content = this.props.loaderContent;
    } else {
      content = (
        <div>
          <StripeCheckout
            name="Update Credit Card"
            panelLabel="Update Card"
            label="Update"
            email={this.props.user.email}
            token={this.onToken}
            stripeKey={stripePublishableKey}
            allowRememberMe={false}
            ComponentClass="div"
            opened={this.onOpen}
          >
            {this.props.content}
          </StripeCheckout>
        </div>
      );
    }

    return content;
  }
}

SubscriptionEdit.propTypes = {
  payment: PropTypes.shape({
    activeSubscription: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    last4: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    stripeWebhookProcessedOn: PropTypes.number,
    stripeCustomerID: PropTypes.string.isRequired
  }),
  user: PropTypes.shape({
    email: PropTypes.string.isRequired
  })
};



// WEBPACK FOOTER //
// ./src/components/SubscriptionEdit.js